import { RemoveQueryParams } from './removeQueryParams';

export const normalizeParam = (param: string | Array<string> | undefined): string | undefined => {
    if (!param) {
        return undefined;
    }
    if (Array.isArray(param)) {
        return param[0];
    }
    return param;
};

export const RoutingUtils = {
    RemoveQueryParams,
    normalizeParam
};
